document.addEventListener('DOMContentLoaded', () => {
  const addSubmitIcon = (button) => {
    if (!button.querySelector('.button__icon')) {
      const span = document.createElement('span');
      span.className = 'button__icon';
      span.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.707 12.6758H11.707V3.41406L1.41406 13.707L0 12.293L10.293 2H1.03125V0H13.707V12.6758Z"/>
        </svg>`;
      button.appendChild(span);
    }
  };

  document.querySelectorAll('.btn-submit').forEach(addSubmitIcon);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          node.querySelectorAll('.btn-submit').forEach(addSubmitIcon);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
